/**
 * @docs docs/features/website-navigation-shell
 */

/*----------------------------------
- MEGA MENU PANEL
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type MegaMenuPanelProps = {
    id: string;
    testId: string;
    isOpen: boolean;
    /** One width per menu, from the mockup: three columns, six rows, four rows. */
    width?: 'wide' | 'medium' | 'narrow';
    children: ComponentChildren;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

const PANEL_WIDTH_CLASS = {
    wide: 'w-[min(1080px,calc(100vw-48px))]',
    medium: 'w-[min(960px,calc(100vw-48px))]',
    narrow: 'w-[min(860px,calc(100vw-48px))]',
} as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * The floating card every desktop megamenu opens in. Position and entrance live in
 * `.ud-landing-mega-menu` (shared.css) because the keyframes carry the centring
 * translate; everything else is utilities so both menus share one chrome.
 * Closed panels stay in the document (`hidden`) so their links remain crawlable.
 */
export default function MegaMenuPanel({ id, testId, isOpen, width = 'wide', children }: MegaMenuPanelProps) {
    return (
        <div
            id={id}
            class={`ud-landing-mega-menu ${PANEL_WIDTH_CLASS[width]}`}
            data-testid={testId}
            hidden={!isOpen}
            aria-hidden={!isOpen}
        >
            <div class="overflow-hidden rounded-[28px] border border-[rgba(223,220,212,0.92)] bg-white/[0.96] px-8 pb-[26px] pt-7 shadow-[0_18px_40px_rgba(27,29,30,0.08)]">
                {children}
            </div>
        </div>
    );
}
